import { createFileRoute, getRouteApi, Link, Outlet, useRouterState } from "@tanstack/react-router";
import type { CurrentUser } from "../../lib/auth";

export const Route = createFileRoute("/_authed/settings")({
  component: SettingsLayout,
});

const _authedRoute = getRouteApi("/_authed");

function SettingsLayout() {
  const ctx = _authedRoute.useRouteContext() as { user?: CurrentUser };
  const user = ctx.user;
  const isAdmin = user?.role_name === "Admin";
  const perms = user?.permissions ?? {};

  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const TABS = [
    { label: "Meu Perfil", to: "/settings/profile", visible: true },
    { label: "Gerenciamento de Equipe", to: "/settings/users", visible: isAdmin || !!perms.config_equipe },
    { label: "Funções", to: "/settings/roles", visible: isAdmin || !!perms.config_funcoes },
    { label: "APIs", to: "/settings/api-keys", visible: isAdmin || !!perms.config_apis },
    { label: "Logs", to: "/settings/logs", visible: isAdmin || !!perms.config_logs },
    { label: "Tags", to: "/settings/tags", visible: isAdmin || !!perms.config_tags },
  ] as const;

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Topbar */}
      <div style={{ height: 52, borderBottom: "1px solid var(--line)", display: "flex", alignItems: "center", padding: "0 24px", flexShrink: 0 }}>
        <span style={{ fontSize: 15, fontWeight: 600 }}>Configurações</span>
      </div>

      {/* Sub-nav tabs */}
      <div style={{ display: "flex", borderBottom: "1px solid var(--line)", flexShrink: 0, padding: "0 24px" }}>
        {TABS.filter((tab) => tab.visible).map((tab) => {
          const active = pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              style={{
                padding: "10px 16px",
                fontSize: 13,
                color: active ? "var(--brand)" : "var(--ink-muted)",
                borderBottom: active ? "2px solid var(--brand)" : "2px solid transparent",
                fontWeight: active ? 500 : 400,
                marginBottom: -1,
                textDecoration: "none",
                transition: "color .12s, border-color .12s",
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: "28px 24px" }}>
        <Outlet />
      </div>
    </div>
  );
}
